export function indexToLetter(index: number): string {
    var letter_a_index = 97;
    return String.fromCharCode(letter_a_index + index);
}

export function genRandonString(length: number) {
    var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var charLength = chars.length;
    var result = '';
    for (var i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * charLength));
    }
    return result;
}
